import { render, staticRenderFns } from "./FilterNEWS_VISIBLE.vue?vue&type=template&id=5196a912&scoped=true&"
import script from "./FilterNEWS_VISIBLE.vue?vue&type=script&lang=js&"
export * from "./FilterNEWS_VISIBLE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196a912",
  null
  
)

export default component.exports